import React from 'react';

const FrontCanvas = React.memo((props) => {
    if (props.item == null) {
        return null;
    }

    let imageUrl = null;
    if (parseInt(props.image) === 1) {
        imageUrl = props.item.image1_url;
    } else if (parseInt(props.image) === 2) {
        imageUrl = props.item.image2_url;
    } else if (parseInt(props.image) === 3) {
        imageUrl = props.item.image3_url;
    } else if (parseInt(props.image) === 4) {
        imageUrl = props.item.image4_url;
    } else if (parseInt(props.image) === 5) {
        imageUrl = props.item.image5_url;
    } else if (parseInt(props.image) === 6) {
        imageUrl = props.item.image6_url;
    }

    return (
        <div className="front-canvas-container">
            <h5>{props.item.name}</h5>
            <div className="horizontal-container">
                <div className="preview-image front-preview">
                    <img src={imageUrl} alt="NRC" />
                </div>
            </div>
        </div>
    );
});

FrontCanvas.propTypes = {

}

export default FrontCanvas;
